/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Range_CustomInputs */

const cs_calendar_range_custom = /** @type {(inputs: Calendar_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastní`)
};

const en_calendar_range_custom = /** @type {(inputs: Calendar_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Calendar_Range_CustomInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_range_custom = /** @type {((inputs?: Calendar_Range_CustomInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Range_CustomInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_range_custom(inputs)
	return cs_calendar_range_custom(inputs)
});